import React from "react";
import { useParams } from "react-router-dom";
import { MessageSquareText } from "lucide-react";
import { PageHeader } from "../../components/common";
import { FlaggedPaymentsPanel } from "../../components/FlaggedPaymentsPanel";
import { ReadOnlyNotice } from "../../components/FeatureGate";
import { useRoleModules } from "../../lib/roleModules";

/**
 * Phase 190 — Supervisor › Flagged Payments (territory only).
 * Supervisors see the excess payments recorded on properties inside their zone / wards and can add comments for the
 * Municipal Admin, who decides (correct the demand / mark reviewed). The API scopes the list; this page only presents it.
 */
export default function SupervisorFlaggedPayments() {
  const { code } = useParams();
  const access = useRoleModules(code);
  const readOnly = access.loaded && !access.canWrite("flagged_payments");
  return (
    <div data-testid="supervisor-flagged-payments-page">
      <PageHeader title="Flagged Payments"
        subtitle="Excess payments recorded in your territory. Open one to see what the property owes, then leave a comment for the Municipal Admin, who corrects the demand or marks the flag reviewed.">
        <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><MessageSquareText className="h-3.5 w-3.5" /> View & comment</span>
      </PageHeader>
      {readOnly && <ReadOnlyNotice what="flagged payments" testId="supervisor-flagged-readonly-notice" className="mb-4" />}
      <FlaggedPaymentsPanel code={code} mode="tenant" testId="supervisor-flagged" readOnly={readOnly}
        propertyLink={(f) => `/${code}/supervisor/properties?focus=${f.property_id}`} />
    </div>
  );
}
